// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"feedbackCard_cardContainer__pl7Mt","card":"feedbackCard_card__1ze8s","feedback":"feedbackCard_feedback__2oB9k"};